import {lazy} from 'react';

import {shared} from './sharedConstants';

const Wealth = lazy(() => import('./pages/Wealth'));
const Questionnaire = lazy(() => import('./pages/Questionnaire'));
const Knowledge = lazy(() => import('./pages/Knowledge'));
const Experience = lazy(() => import('./pages/Experience'));
const Accredited = lazy(() => import('./pages/Accredited'));
const Thanks = lazy(() => import('./pages/Thanks'));
const Review = lazy(() => import('./pages/Review'));
const Progress = lazy(() => import('./pages/Progress'));
const FailedTest = lazy(() => import('./pages/FailedTest'));
const Locked = lazy(() => import('./pages/Locked'));
const PassedTest = lazy(() => import('./pages/PassedTest'));
const Mistake = lazy(() => import('./pages/Mistake'));
const NotQualified = lazy(() => import('./pages/NotQualified'));

const paths = {...shared.routes};
const routes = [
  {
    path: paths.root,
    component: Wealth,
    exact: true,
  },
  {
    path: paths.questionnaire.root,
    component: Questionnaire,
    exact: true,
  },
  {
    path: paths.knowledge.root,
    component: Knowledge,
    exact: true,
  },
  {
    path: paths.experience.root,
    component: Experience,
    exact: true,
  },
  {
    path: paths.accredited.root,
    component: Accredited,
    exact: true,
  },
  {
    path: paths.thanks.root,
    component: Thanks,
    exact: true,
  },
  {
    path: paths.review.root,
    component: Review,
    exact: true,
  },
  {
    path: paths.progress.root,
    component: Progress,
    exact: true,
  },
  {
    path: paths.failedtest.root,
    component: FailedTest,
    exact: true,
  },
  {
    path: paths.locked.root,
    component: Locked,
    exact: true,
  },
  {
    path: paths.passedtest.root,
    component: PassedTest,
    exact: true,
  },
  {
    path: paths.mistake.root,
    component: Mistake,
    exact: true,
  },
  {
    path: paths.notqualified.root,
    component: NotQualified,
    exact: true,
  },
];

export default routes;
